import React, { useEffect, useRef } from "react";
import ArticleSearchContainer from "../../../containers/ArticleSearchContainer";
import SORT_OPTIONS from "../common/portalSearch";

function PortalPCSortTabs() {
  const { sort, setSort, search, isRestoringState } =
    ArticleSearchContainer.useContainer();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    // NOTE: ブラウザバック/フォワードで並び替えを復元しただけの場合は、復元処理側で再検索するため検索しない
    if (isRestoringState) return;
    search();
  }, [sort]);

  return (
    <div className="portalPcSortTabs" role="group" aria-label="並び替え">
      {SORT_OPTIONS.map((option) => (
        <button
          key={option.value}
          type="button"
          className={`portalPcSortTab${
            sort === option.value ? " isActive" : ""
          }`}
          aria-pressed={sort === option.value}
          onClick={() => setSort(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}

export default PortalPCSortTabs;
